import { useAuthContext } from './context';
import type { AuthContextValue } from './types';

/**
 * Returns the current auth context: authentication state, account info,
 * and `signIn` / `signOut` / `getAccessToken` actions.
 *
 * Must be called inside an {@link AuthProvider} tree.
 */
export function useAuth(): AuthContextValue {
  return useAuthContext();
}
